// src/components/AuthenticatedLayout.jsx
import React, { useState, useCallback } from 'react';
import Sidebar from './Sidebar/Sidebar';
import MobileTopBar from './MobileTopBar/MobileTopBar';
import PortraitLock from './Responsive/PortraitLock';
import { useIsMobile } from '../hooks/useIsMobile';
import useDrawerBackNavigation from '../hooks/useDrawerBackNavigation';

const AuthenticatedLayout = ({ children }) => {
  const isMobile = useIsMobile();
  const [drawerOpen, setDrawerOpen] = useState(false);
  // Which page the drawer is showing. Lives here rather than in Sidebar
  // because the back-gesture handler below has to read it.
  const [drawerView, setDrawerView] = useState('nav');

  const closeDrawer = useCallback(() => {
    setDrawerOpen(false);
    // Reset so reopening never lands on Settings unexpectedly.
    setDrawerView('nav');
  }, []);

  const backToNav = useCallback(() => setDrawerView('nav'), []);

  // Mobile: the OS back gesture steps settings -> nav -> closed. The two
  // handlers it hands back drive the SAME channel for the on-screen back
  // arrow and the backdrop, so the history stack never desynchronises from
  // the drawer's state — see the hook for the two bugs that requires.
  const { goBack, requestClose } = useDrawerBackNavigation({
    active: isMobile && drawerOpen,
    view: drawerView,
    onBack: backToNav,
    onClose: closeDrawer,
  });

  // Desktop: byte-identical to the original shell.
  if (!isMobile) {
    return (
      <div className='authenticated-layout'>
        <Sidebar />
        <div className='main-content'>{children}</div>
      </div>
    );
  }

  // Mobile (≤768px): slim top bar + off-canvas drawer instead of the rail.
  return (
    <div className='authenticated-layout authenticated-layout--mobile'>
      <PortraitLock />
      <MobileTopBar onMenuClick={() => setDrawerOpen(true)} />
      <Sidebar
        variant='drawer'
        open={drawerOpen}
        view={drawerView}
        onViewChange={setDrawerView}
        onBack={goBack}
        onClose={requestClose}
      />
      <div className='main-content main-content--mobile'>{children}</div>
    </div>
  );
};

export default AuthenticatedLayout;
